<!-- <app-dashboard-sidemenu></app-dashboard-sidemenu> -->
<p-toast></p-toast>
<!-- <p-confirmDialog [breakpoints]="{'850px' : '90vw'}" [style]="{width: '50vw'}"acceptButtonStyleClass="p-button-text" [style]="{ width: '30vw' }" header="Confirmation"
    [baseZIndex]="10000" rejectButtonStyleClass="p-button-text">
</p-confirmDialog> -->
<p-confirmDialog [breakpoints]="{'850px' : '90vw'}" [style]="{width: '35vw'}" header="Confirmation"></p-confirmDialog>
<!-- ********************** Main Content ******************** -->

<!-- <div class="main-content d-flex flex-column"> -->
<!-- <app-dashboard-navbar></app-dashboard-navbar> -->
<ng-container >
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <!-- <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li> -->
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
</ng-container>
<!-- <app-navbar-style-one></app-navbar-style-one> -->
<!-- HWM member list table -->
<section class="hwm-member-list">
    <div >
        
        <div >
            <div class="theader">

                <div class="d-flex">
                    <span class="p-input-icon-left ml-auto mr-2">
                        <i class="pi pi-search"></i>
                        <input class="form-control" pInputText type="text" placeholder="Search Keyword"
                            [(ngModel)]="filterVal" (input)="nameFilter.filterGlobal($event.target.value,
                        'contains')" />
                    </span>
                    <p-button type="button" class="mx-2" (click)="reset(nameFilter)" icon="bx bx-reset"
                        [pTooltip]="tooltipText" tooltipPosition="bottom">
                    </p-button>
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="onXLSExport()"
                        class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"
                        *ngIf="localStorage.role == 'Admin'"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="onPDFExport()"
                        class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"
                        *ngIf="localStorage.role == 'Admin'"></button>
                    <!-- <p-button type="button" class="mx-2" (click)="applyFilter()" tooltipPosition="bottom" label="Apply Filter"></p-button> -->
                </div>
            </div>
            <!-- HWM Listing -->
            <!-- *ngIf="((localStorage.role == 'Admin' || localStorage.role == 'UCCI Staff') ? response?.data?.length > 0 : response?.member_data?.length == 0)" -->
            <ng-container>
                <p-table #nameFilter [rows]="10" dataKey="id" rowGroupMode="subheader" [showCurrentPageReport]="true"
                    sortOrder="1" [loading]="loading" sortMode="multiple" styleClass="p-datatable-sm
                    p-datatable-customers" [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll"
                    scrollable="true" scrollHeight="600px" [paginator]="true"  [globalFilterFields]="['company_name' , 'email']"
                    [value]="terminatedlist"
                    [tableStyle]="{'min-width': '50rem', 'width' : '100%'}">
                    <!-- currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="min-width: 62px;">S. No.</th>
                            <th style="min-width: 100px;">Action</th>
                            <th style="min-width: 160px;" pSortableColumn="status">
                                Status<p-sortIcon field="status">
                                </p-sortIcon>
                            </th>
                            <th style="min-width: 200px;" pSortableColumn="company_name">Company Name<p-sortIcon
                                    field="company_name">
                                </p-sortIcon>
                            </th>

                            <th  pSortableColumn="membership_no">Email<p-sortIcon field="membership_no">
                                </p-sortIcon></th>
                        </tr>
                        <tr>
                            <th *ngFor="let item of colFilter" [ngSwitch]="item.field">
                                <!-- <div *ngSwitchCase="'S. No.'"></div> -->
                                <!-- <div *ngSwitchCase="'action'"></div> -->
                                <!-- <p-columnFilter [showClearButton]="false" *ngSwitchCase="'status'" field="status"
                                    matchMode="equals" [showMenu]="false">
                                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                        <p-dropdown [ngModel]="statusFilter" [appendTo]="nameFilter" [options]="status"
                                            (onChange)="filter($event.value)" placeholder="Select" [showClear]="false"
                                            [resetFilterOnHide]="true">
                                            <ng-template let-option pTemplate="item">
                                                <span>{{option.label}}</span>
                                            </ng-template>
                                        </p-dropdown>
                                    </ng-template>
                                </p-columnFilter> -->
                                <input placeholder="Keyword" *ngSwitchCase="'company_name'" field="company_name"
                                    pInputText class="p-inputtext p-component p-element" type="text"
                                    [(ngModel)]="company_name" (input)="nameFilter.filter($event.target.value,
                                    'company_name', 'contains')" style="height: 30px;">
                                   <input placeholder="Keyword" *ngSwitchCase="'email'" field="email"
                                    pInputText class="p-inputtext p-component p-element" type="text"
                                    [(ngModel)]="email" (input)="nameFilter.filter($event.target.value,
                                    'member?.email', 'contains')" style="height: 30px;">
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-hwmMemberList let-i="rowIndex">
                        <ng-container >
                            <tr>
                                <!-- <td><button type="button" pButton pRipple
                                        class="p-button-text p-button-rounded
                                        p-button-plain p-mr-2" [icon]="expanded
                                        ? 'pi pi-chevron-down' :
                                        'pi pi-chevron-right'"
                                        [pRowToggler]="hwmMemberList"></button></td> -->
                                        
                                <td style="min-width: 80px;">{{i + 1}}</td>
                                <td style="display:flex !important">
                                       <ng-container >
                                             <button pButton pRipple 
                                                 (click)="terminatted(hwmMemberList.member_id, hwmMemberList.status,'terminate',hwmMemberList)" class="p-button-rounded p-button-text
                                            p-button-danger" pTooltip="Terminate" tooltipPosition="bottom">
                                                <i class="bx bx-message-alt-x"></i>
                                            </button>
                                        </ng-container>
                                            <!-- <button pButton pRipple 
                                                (click)="approveMemberById(hwmMemberList.id, hwmMemberList.status)" class="p-button-rounded p-button-text
                                            p-button-success" pTooltip="Approve" tooltipPosition="bottom">
                                                <i class="bx bx-message-alt-x"></i>
                                            </button> -->
                                           <!-- <ng-container>
                                            <button pButton pRipple 
                                                (click)="approveMemberById('verification',
                                            hwmMemberList.member_id, 1, hwmMemberList, hwmMemberList.status)" class="p-button-rounded p-button-text
                                            p-button-success" pTooltip="Verify" tooltipPosition="bottom">
                                                <i class="fas fa-badge-check"></i>
                                            </button>
                                        </ng-container> -->
                                </td>
                                
                                <td class="status">
                                    <ng-container *ngIf="hwmMemberList?.status
                                    ==
                                    'Terminated'">
                                        <span class="terminated">
                                            {{ hwmMemberList?.status }}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngIf="hwmMemberList?.status
                                    ==
                                    'Provisionally Terminated'">
                                        <span class="terminated" style="background-color: #692f35 !important">
                                            {{ hwmMemberList?.status }}
                                        </span>
                                    </ng-container>
                                </td>
                                <td>{{hwmMemberList.company_name | titlecase}}</td>
                               <td>{{ hwmMemberList?.member?.email ? hwmMemberList.member.email : '-' }}</td>

                                
                            </tr>
                        </ng-container>
                                       <!-- <p-dialog header="Verification" [(visible)]="VerificationDialog" [modal]="true" [style]="{ width: '35vw' }"
    [breakpoints]="{'850px' : '90vw'}" [draggable]="false" [resizable]="false">
    <table>
        <thead>
            <tr>
                <th>Verified by</th>
                <th>Status</th>
                <th>Remark/Reason</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let record of verificationdata; let i = index">
                <ng-container *ngFor="let step of [1, 2, 3]">
                    <tr *ngIf="record['vid_' + step]">
                        <td>{{ userNameMap[record['vid_' + step]] }}</td>
                        <td>
                            {{
                            record['verification' + step] == '1'
                            ? 'Verified'
                            : (record['verification' + step] == '0' ? 'Discrepant' : '')
                            }}
                        </td>
                        <td>{{ record['vremarks_' + step] }}</td>
                    </tr>
                </ng-container>
            </ng-container>
        </tbody>

    </table>
    <ng-container *ngIf="localStorage.role == 'President'">
        <div class="add-listings-btn">
            <button class="button success-btn mr-2" (click)="approvalProcess(1)">Approve</button>
            <button class="button reject-btn mr-2" (click)="approvalProcess(0)">Reject</button>
        </div>
    </ng-container>
    <ng-container *ngIf="localStorage.role != 'President'">
        <form [formGroup]="verificationForm" (ngSubmit)="verificationFormFunction(hwmverification)"
            #hwmverification="ngForm">
            <div class="upload-dialog">
                <div class="form-group">
                    <label class="mb-3" for="">
                        Remark<span class="required">*</span></label>
                    <textarea type="text" placeholder="Remark/Reason" formControlName="remark" [class.is-invalid]="(hwmverification.submitted &&
            verificationForm.get('remark')?.invalid) ||
            verificationForm.get('remark')?.invalid &&
            verificationForm.get('remark').touched" class="form-control" required>
            </textarea>
                    <div class="invalid-feedback" style="margin-top: 1.25rem;">Remark is Required
                    </div>
                </div>
                <br>
                <div class="add-listings-btn">
                    <button class="button success-btn mr-2" (click)="document_status = 'Verified'">Verify</button>
                    <button class="button reject-btn mr-2"
                        (click)="document_status = 'Discrepancy'">Discrepancy</button>
                </div>
            </div>
        </form>
    </ng-container>
</p-dialog> -->
                    </ng-template>
     
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="9">No Data Found.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </ng-container>
        <p-dialog header="Termination" [(visible)]="TerminationDialog" [modal]="true"
    [style]="{ width: '35vw' }" [breakpoints]="{'850px' : '90vw'}"
    [draggable]="false" [resizable]="false">

  <!-- Show table only when data exists -->
  <ng-container *ngIf="selectedMember?.terminate_verification; else noData">
    <table>
      <thead>
        <tr>
          <th>Terminated by</th>
          <th>Status</th>
          <th>Remark/Reason</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let step of [1, 2, 3]">
          <tr *ngIf="selectedMember.terminate_verification['tvid_' + step]">
            <td>{{ selectedMember['verifier_' + step] }}</td>
            <td>
              {{
                selectedMember.terminate_verification['tverification' + step] === 1
                  ? 'Terminated'
                  : (selectedMember.terminate_verification['tverification' + step] === 0
                    ? 'Discrepant'
                    : '')
              }}
            </td>
            <td>{{ selectedMember.terminate_verification['tvremarks_' + step] }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-container>

  <!-- fallback template when data is not ready -->
  <ng-template #noData>
    <p>No termination records available yet.</p>
  </ng-template>

  <!-- President actions -->

  <!-- Other roles: form -->
  <ng-container *ngIf="localStorage.role != ''">
    <form [formGroup]="verificationForm" (ngSubmit)="verificationFormFunction(hwmverification)"
      #hwmverification="ngForm">
      <div class="upload-dialog">
        <div class="form-group">
          <label class="mb-3" for="">Remark<span class="required">*</span></label>
          <textarea type="text" placeholder="Remark/Reason" formControlName="remark"
            [class.is-invalid]="(hwmverification.submitted &&
              verificationForm.get('remark')?.invalid) ||
              verificationForm.get('remark')?.invalid &&
              verificationForm.get('remark').touched"
            class="form-control" required>
          </textarea>
          <div class="invalid-feedback" style="margin-top: 1.25rem;">Remark is Required</div>
        </div>
        <br>
        <div class="add-listings-btn">
          <button type="submit" class="button reject-btn mr-2">Submit</button>
        </div>
      </div>
    </form>
  </ng-container>
</p-dialog>
        </div>
      
     
    </div>
</section>
